<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <span class="title">{{title}}</span>
          </div>
        </div>
        <div class="modal-body-cust">
          <div class="d-flex">
            <div>
              <img :src="`${BaseUrl}assets/pdf_${pdfType}.png`" />
            </div>
            <div class="content mt-4">
              <content>
                <slot name="content"></slot>
              </content>
            </div>
            <!--  兩個頁籤 vue 共用此 modal  -->
            <a @click="$emit('close')" class="btn btn-primary btn-style checkButton">確定</a>
          </div>
          <div class="action text-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "mvInfo",
  computed: {
    ...mapGetters(["BaseUrl"]),
    pdfType() {
    //20250725 保單篩選之保單種類說明彈窗
    return this.$props.type === '24' ? '01' : this.$props.type;
  }
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  methods: {},
};
</script>

<style scoped>
.title {
  width: 264px;
  height: 33px;
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}
.content {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.65;
  letter-spacing: normal;
  color: #323a45;
}
.modal-body-cust {
  padding: 20px 20px;
}
.checkButton {
  position: fixed;
  bottom: 40px;
  right: 40px;
}
.btn-style {
  width: 120px;
  height: 40px;
}
.pre-formatted {
  white-space: pre;
}
</style>